import * as React from "react"
const UyfIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250" {...props}>
    <path d="M133.1 87.3h23.6l6.5-20.9 17.4 3.5C179.4 65 168 12.5 168 12.5s-34 34.9-43.4 46.2L141 62zm56.8 141.6c-3.9-14.2-15.8-57.5-15.8-66.4v-61.1c0-3.7-3-6.8-6.8-6.8H70.2c-3.7 0-6.8 3-6.8 6.8v61.1c0 1.5-.4 6-3.4 18.8-.8 3.7 1.4 7.3 5.1 8.1s7.3-1.4 8.2-5.1c3.4-14.5 3.8-19.4 3.8-21.8v-54.3h83.5v54.3c0 7.6 4.7 27.9 16.3 70 .8 3 3.6 5 6.5 5 .6 0 1.2-.1 1.8-.2 3.6-1 5.7-4.8 4.7-8.4" />
  </svg>
)
export default UyfIcon
